// ============================================================================
// ROLE PERMISSION ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/RolePermissions';

export const rolePermissionEndpoints = {
  basePath: () => BASE_PATH,
  list:     () => buildEndpoint(BASE_PATH),
  getById:  (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id: String(id) }),
  byRoles:  () => `${BASE_PATH}/by-roles`,
  create:   () => buildEndpoint(BASE_PATH),
  update:   (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id: String(id) }),
  delete:   (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id: String(id) }),
} as const;

export default rolePermissionEndpoints;
